import { FEATURE_FLAGS, REDIS_FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = (accountId, locale = 'pt_BR', claudiaOnly = false) => {
  // Map locale to URL code
  const localeMap = {
    en: 'en',
    es: 'es',
  };

  const faqLocale = localeMap[locale] || 'pt_BR';
  const faqUrl = `https://cloudchat.cloudhumans.com/hc/cloud-chat/${faqLocale}`;

  return [
    {
      icon: 'mail-inbox',
      key: 'inboxView',
      label: 'INBOX_VIEW',
      featureFlag: FEATURE_FLAGS.INBOX_VIEW,
      toState: frontendURL(`accounts/${accountId}/inbox-view`),
      toStateName: 'inbox_view',
    },
    {
      icon: 'chat-alt-6',
      key: 'conversations',
      label: 'CONVERSATIONS',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
      toStateName: 'home',
    },
    {
      icon: 'captain',
      key: 'captain',
      label: 'CAPTAIN',
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      toState: frontendURL(`accounts/${accountId}/captain`),
      toStateName: 'captain',
    },
    {
      icon: 'claudia',
      key: 'claudia',
      label: 'CLAUDIA',
      redisFeatureFlag: REDIS_FEATURE_FLAGS.CLAUDIA,
      keepInClaudiaOnly: true,
      toState: frontendURL(`accounts/${accountId}/claudia`),
      toStateName: 'claudia_app',
    },
    {
      icon: 'users-2',
      key: 'contacts',
      label: 'CONTACTS',
      featureFlag: FEATURE_FLAGS.CRM,
      toState: frontendURL(`accounts/${accountId}/contacts`),
      toStateName: 'contacts_dashboard',
    },
    {
      icon: 'graph-increase',
      key: 'reports',
      label: 'REPORTS',
      featureFlag: FEATURE_FLAGS.REPORTS,
      // In Claudia-only mode the Reports section is collapsed to the Omni report
      // builder only, so the primary nav item points straight at create-mode.
      toState: claudiaOnly
        ? frontendURL(`accounts/${accountId}/reports/create-mode`)
        : frontendURL(`accounts/${accountId}/reports`),
      toStateName: claudiaOnly
        ? 'reports_create_mode'
        : 'account_overview_reports',
      keepInClaudiaOnly: claudiaOnly ? true : undefined,
    },
    {
      icon: 'megaphone-2',
      key: 'campaigns',
      label: 'CAMPAIGNS',
      featureFlag: FEATURE_FLAGS.CAMPAIGNS,
      toState: frontendURL(`accounts/${accountId}/campaigns`),
      toStateName: 'one_off',
    },
    {
      icon: 'library',
      key: 'helpcenter',
      label: 'HELP_CENTER.TITLE',
      featureFlag: FEATURE_FLAGS.HELP_CENTER,
      alwaysVisibleOnChatwootInstances: true,
      toState: frontendURL(`accounts/${accountId}/portals`),
      toStateName: 'default_portal_articles',
    },
    {
      icon: 'cog',
      key: 'settings',
      label: 'SETTINGS',
      toState: claudiaOnly
        ? frontendURL(`accounts/${accountId}/settings/agents`)
        : frontendURL(`accounts/${accountId}/settings`),
      toStateName: claudiaOnly ? 'agent_list' : 'settings_home',
      keepInClaudiaOnly: claudiaOnly ? true : undefined,
    },
    {
      icon: 'question-circle',
      key: 'faq',
      label: 'FAQ',
      openInNewPage: true,
      keepInClaudiaOnly: true,
      toState: faqUrl,
      toStateName: 'faq',
    },
    {
      icon: 'invention',
      key: 'product-feedback',
      label: 'PRODUCT_FEEDBACK',
      openInNewPage: true,
      keepInClaudiaOnly: true,
      toState: 'https://cloudhumans.canny.io/feature-request-cloud-chat',
      toStateName: 'product_feedback',
    },
  ];
};

export default primaryMenuItems;
